import React from "react";

const LogoutIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.96667 18C2.41667 18 1.94584 17.8042 1.55417 17.4125C1.16251 17.0208 0.966675 16.55 0.966675 16V2C0.966675 1.45 1.16251 0.979167 1.55417 0.5875C1.94584 0.195833 2.41667 0 2.96667 0H9.96667V2H2.96667V16H9.96667V18H2.96667ZM13.9667 14L12.5917 12.55L15.1417 10H6.96667V8H15.1417L12.5917 5.45L13.9667 4L18.9667 9L13.9667 14Z"
        fill="#95A1B3"
      />
    </svg>
  );
};

export default LogoutIcon;
